<template>
  <b-row>
    <b-col cols="12">
      <b-form-group>
        <v-select
          v-if="categories.length > 0"
          v-model="selected"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          label="name"
          :options="categories"
          class="select-size-lg"
          :reduce="c => c"
        >
          <template #option="{ name, description }">
            <span>{{ $t(name) }}</span><br />
            <small class="text-muted">{{ $t(description) }}</small>
          </template>
        </v-select>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BFormGroup } from 'bootstrap-vue'
import vSelect from 'vue-select'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    vSelect,
  },

  props: {
    initialCategory: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      categories: [],
      selected: null,
    }
  },

  async created() {
    await this.fetchCategories()
  },

  methods: {
    async fetchCategories() {
      try {
        const response = await axios.get('/lms/admin/course/getcoursemodes')
        const { data } = response.data
        this.categories = data || []

        // Varsayılan seçim
        this.selected = this.initialCategory || this.categories[0] || null
      } catch (error) {
        console.error('Kategori verileri alınamadı:', error)
      }
    },
  },

  watch: {
    selected(newVal) {
      this.$emit('selectionChanged', newVal)
    }
  }
}
</script>
